import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home'
import Booking from '@/components/booking'

import paymentSuccess from '@/components/paymentSuccessful'
import paymentFail from '@/components/paymentFail'

import contact from '@/components/contact'
import privacy from '@/components/privacyPolicy'
import refund from '@/components/returnPolicy'
import checkout from '@/components/checkout'
import confirmation from '@/components/confirmation'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:playlistId/:playlistName/booking',
      name: 'Booking',
      component: Booking,
      meta: {
        showBackBtn: true,
        bgBlack: false
      }
    },
    {
      path: '/contact-us',
      name: 'ContactUs',
      component: contact,
      meta: {
        showBackBtn: true,
        bgBlack: true
      }
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: privacy,
      meta: {
        showBackBtn: true,
        bgBlack: true
      }
    },
    {
      path: '/refund-policy',
      name: 'RefundPolicy',
      component: refund,
      meta: {
        showBackBtn: true,
        bgBlack: true
      }
    },
    {
      path: '/success',
      name: 'Success',
      component: paymentSuccess,
      meta: {
        showBackBtn: false,
        bgBlack: false
      }
    },
    {
      path: '/fail',
      name: 'Failed',
      component: paymentFail,
      meta: {
        showBackBtn: false,
        bgBlack: false
      }
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: checkout,
      meta: {
        showBackBtn: true,
        bgBlack: false
      }
    },
    {
      path: '/:media_id/:activity_id/confirmation',
      name: 'Confirmation',
      component: confirmation,
      meta: {
        showBackBtn: false,
        bgBlack: false
      }
    },
    {
      path: '/:id?/:name?',
      name: 'Home',
      component: Home,
      meta: {
        showBackBtn: false,
        bgBlack: false
      }
    },
    {
      path: '/*',
      redirect: {
        name: 'Home'
      }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.name !== from.name) {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js